"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SocialExpandButton = require("./SocialExpandButton");
Object.keys(_SocialExpandButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SocialExpandButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SocialExpandButton[key];
    }
  });
});
var _SocialButton = require("./SocialButton");
Object.keys(_SocialButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SocialButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SocialButton[key];
    }
  });
});
var _SocialsWrapper = require("./SocialsWrapper");
Object.keys(_SocialsWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SocialsWrapper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SocialsWrapper[key];
    }
  });
});